import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

export const QueueDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  
  return (
    <>
      <Helmet>
        <title>Очередь {id} - ELEKTROM</title>
      </Helmet>
      
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          Детали очереди {id}
        </Typography>
        <Paper sx={{ p: 3, mt: 2 }}>
          <Typography variant="body1">
            Страница деталей очереди находится в разработке.
          </Typography>
        </Paper>
      </Box>
    </>
  );
};
